import { BottomServiceVariants } from './types';

/*  eslint-disable-next-line @typescript-eslint/no-unused-vars */
const mapVariantToColor = (_variant: BottomServiceVariants) => Styles.color.bsmPrimary;

export default mapVariantToColor;
